import { useMemo, useState } from "react"
import ProfileLayout from "../../../../commons/ProfileLayout/ProfileLayout"
import { ProfileSubUsersENTContext } from "./ProfileSubUsersENT.context"
import ProfileSubUsersListTable from "./ProfileSubUsersListTable/ProfileSubUsersListTable"
import { SubUser } from "../../../../../types/models/user/user.types"
import UpdateSubUserModal from "./UpdateSubUserModal/UpdateSubUserModal"
import AddSubUserENTModal from "./AddSubUserENTModal/AddSubUserENTModal"

export default () => {

  const [isAddModalOpen, setAddModalOpen] = useState(false)
  
  const [subUserToUpdate, setSubUserToUpdate] = useState<SubUser>()
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false)

  const contextValue = useMemo(
    () => ({
      subUserToUpdate,
      setSubUserToUpdate,
      isUpdateModalOpen,
      setUpdateModalOpen,
      isAddModalOpen,
      setAddModalOpen
    }),
    [
      subUserToUpdate,
      setSubUserToUpdate,
      isUpdateModalOpen,
      setUpdateModalOpen,
      isAddModalOpen,
      setAddModalOpen
    ]
  )

  return (
    <ProfileSubUsersENTContext.Provider value={contextValue}>
      <ProfileLayout>
        <ProfileSubUsersListTable />
      </ProfileLayout>
      <AddSubUserENTModal 
        isOpen={isAddModalOpen}
        setOpen={setAddModalOpen}
      />
      <UpdateSubUserModal 
        isOpen={isUpdateModalOpen}
        setOpen={setUpdateModalOpen}
      />
    </ProfileSubUsersENTContext.Provider>
  )
}